module.exports = __webpack_public_path__ + "static/media/contemplar_te_3.59c5679a.jpg";